const frTranslation = () => {
    return {
        common: {
            markAsComplete: 'Marquer comme terminé',
            markAsIncomplete: 'Marquer comme non terminé',
            inactive: 'Inactif',
            lastUpdated: 'Dernière mise à jour',
            edit: 'Modifier',
            create: 'Créer',
            save: 'Enregistrer',
            update: 'Mettre à jour',
            saving: 'Enregistrement...',
            cancel: 'Annuler',
            delete: 'Supprimer',
            duplicate: 'Dupliquer',
            search: 'Rechercher',
            title: 'Titre',
            description: 'Description',
            intensity: 'Intensité',
            areYouSure: 'Êtes-vous sûr ?',
            none: 'Aucun',
            all: 'Tous',
            sessionExpired: 'Votre session a expiré',
            errorOccurred: 'Une erreur est survenue',
            success: 'Succès',
            confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
            requiredField: 'Ce champ est requis',
            error: 'Erreur',
            warning: 'Avertissement',
            info: 'Information',
            confirm: 'Confirmer',
            back: 'Retour',
            next: 'Suivant',
            previous: 'Précédent',
            loading: 'Chargement...',
            noData: 'Aucune donnée disponible',
            actions: 'Actions',
            close: 'Fermer',
            submit: 'Soumettre',
            reset: 'Réinitialiser',
            invalidEmail: 'Email invalide',
            invalidPhone: 'Numéro de téléphone invalide',
            invalidUrl: 'URL invalide',
            invalidDate: 'Date invalide',
            invalidTime: 'Heure invalide',
            invalidDatetime: 'Date et heure invalides',
            invalidNumber: 'Nombre invalide',
            invalidInteger: 'Nombre entier invalide',
            invalidDecimal: 'Nombre décimal invalide',
            invalidPassword: 'Mot de passe invalide',
            invalidConfirmPassword: 'Les mots de passe ne correspondent pas',
            invalidMinLength: 'Doit contenir au moins {min} caractères',
            invalidMaxLength: 'Ne doit pas dépasser {max} caractères',
            active: 'Actif',
            yes: 'Oui',
            no: 'Non',
            status: 'Statut',
            showCompleted: 'Afficher les terminés',
            completed: 'Terminé',
            created: 'Créé le',
            copy: 'Copier',
            copied: 'Copié',
            filters: 'Filtres',
            noResults: 'Aucun résultat',
            noMoreResults: 'Plus de résultats',
            details: 'Détails',
        },
        filter: {
            search: {
                placeholder: 'Rechercher...',
            },
            category: {
                label: 'Catégorie',
                all: 'Toutes les catégories',
            },
            sort: {
                label: 'Trier par',
                default: 'Défaut',
            },
            resultsCount: '{{count}} résultat(s) trouvé(s)',
            resetAll: 'Réinitialiser tout',
        },
        faq: {
            title: 'Foire aux questions',
            noFaq: 'Aucune question fréquente disponible pour le moment.',
            deleteSuccess: 'La question a été supprimée avec succès',
            deleteError: 'Une erreur est survenue lors de la suppression de la question',
            updateSuccess: 'La question a été mise à jour avec succès',
            manage: 'Gestion de la FAQ',
            edit: 'Modifier la question',
            create: 'Créer une question',
            createSuccess: 'La question a été créée avec succès',
            categories: {
                all: 'Toutes les catégories',
                general: 'Général',
                account: 'Compte',
                subscription: 'Abonnement',
                payment: 'Paiement',
                other: 'Autre',
            },
            form: {
                question: 'Question',
                questionPlaceholder: 'Saisissez votre question ici...',
                answer: 'Réponse',
                answerPlaceholder: 'Saisissez votre réponse ici...',
                category: 'Catégorie',
                order: "Ordre d'affichage",
                isActive: 'Actif',
                newQuestion: 'Nouvelle question',
                editQuestion: 'Modifier la question',
                createSuccess: 'La question a été créée avec succès',
                updateSuccess: 'La question a été mise à jour avec succès',
                deleteSuccess: 'La question a été supprimée avec succès',
                deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette question ?',
                validation: {
                    questionRequired: 'La question est requise',
                    answerRequired: 'La réponse est requise',
                    categoryRequired: 'La catégorie est requise',
                },
            },
            filter: {
                category: 'Filtrer par catégorie',
                showInactive: 'Afficher les questions inactives',
            },
            invalidMinValue: 'Doit être supérieur ou égal à {min}',
            invalidMaxValue: 'Doit être inférieur ou égal à {max}',
            showCompleted: 'Afficher les terminées',
            hideCompleted: 'Masquer les terminées',
            completed: 'Terminé',
            invalidPattern: 'Format invalide',
            invalidRequired: 'Ce champ est requis',
            invalidUrlFormat: "Format d'URL invalide",
            invalidEmailFormat: "Format d'email invalide",
            invalidPhoneFormat: 'Format de téléphone invalide',
            invalidDateRange: 'La date de fin doit être postérieure à la date de début',
            invalidTimeRange: "L'heure de fin doit être postérieure à l'heure de début",
            invalidDatetimeRange: 'La date et heure de fin doivent être postérieures à la date et heure de début',
        },

        global: {
            monday: 'Lundi',
            tuesday: 'Mardi',
            wednesday: 'Mercredi',
            thursday: 'Jeudi',
            friday: 'Vendredi',
            saturday: 'Samedi',
            sunday: 'Dimanche',
            today: "Aujourd'hui",
            lang: {
                fr: 'France (French)',
                gb: 'Anglais (English)',
                br: 'Brésil (Brazil)',
            },
            back: 'Retour',
        },
        home: {
            'main-title': "Badminton Villeneuve d'Ascq",
            'presentation-1': 'Jeunes et adultes, compétiteurs et loisirs, ',
            'presentation-2': 'le ',
            'presentation-3': 'BVA',
            'presentation-4': ' accompagne tous les joueurs de badminton à prendre du plaisir.',
            'last-news': 'Derniers articles',
        },
        header: {
            menu: {
                home: 'Accueil',
                planning: 'Horaires & Tarifs',
                registration: 'Inscription',
                badnetTournaments: 'Compétitions',
                contact: 'Contactez-nous',
                faq: 'FAQ',
                'my-space-bva': 'Mon espace BVA',
                login: 'Se connecter',
                connect: 'Se connecter',
            },
            'my-tournament-account': 'Mon compte tournoi',
            'tournament-account-message':
                "Le compte tournoi commence à 0€ et peut atteindre 25€ maximum. Il concerne uniquement la Licence Compétiteur. Pour le remplir rien de plus simple, il faut participer aux entraînements et prévenir en cas d'absence.",
        },
        footer: {
            copyright: `Copyright ${new Date().getFullYear()}. Tous droits réservés - Site créé par`,
            administration: 'Administration',
        },
        intensity: {
            low: 'Faible',
            medium: 'Moyenne',
            high: 'Élevée',
            very_high: 'Très élevée',
            extreme: 'Extrême',
        },
        sidebar: {
            admin: {
                dashboard: 'Tableau de bord',
                user: 'Utilisateurs',
                news: 'Articles',
                partners: 'Partenaires',
                badnet: 'Calendrier des Compétitions',
                plannings: 'Plannings',
                prices: 'Tarifs',
                documentation: 'Documentation',
                'bva-bot': 'BVA bot',
                'to-document-myself': 'Me documenter',
                coachs: 'Coachs',
                carousel: 'Diaporama',
                faq: 'FAQ',
                'training-sessions': "Sessions d'entraînement",
                'training-session-groups': 'Groupes de séances',
            },
            member: {
                'my-progression': 'Ma progression',
                password: 'Mot de passe',
                'satisfaction-survey': 'Questionnaire de satisfaction',
            },
        },
        adminDashboard: {
            showConfig: 'Configurer le dashboard',
            hideConfig: 'Masquer la configuration',
            widgets: {
                userStats: {
                    title: 'Statistiques utilisateurs',
                    total: 'Total utilisateurs',
                    members: 'Membres',
                    coaches: 'Coachs',
                    admins: 'Admins',
                },
                shopStats: {
                    title: 'Statistiques boutique',
                    totalOrders: 'Total commandes',
                    pendingOrders: 'Commandes en attente',
                },
                newsStats: {
                    title: 'Statistiques articles',
                    total: 'Total articles',
                    recent: 'Articles récents',
                },
                badnetStats: {
                    title: 'Statistiques Badnet',
                    upcoming: 'Tournois à venir',
                    queue: 'En attente',
                    syncStatus: 'Statut de synchronisation',
                },
                quickActions: {
                    title: 'Actions rapides',
                    addUser: 'Ajouter un utilisateur',
                    addArticle: 'Ajouter un article',
                    addProduct: 'Ajouter un produit',
                    addPartner: 'Ajouter un partenaire',
                },
                notifications: {
                    title: 'Notifications',
                    pendingOrders: 'Commandes en attente',
                    orders: 'commandes',
                    noAlerts: 'Aucune alerte',
                },
            },
            config: {
                title: 'Configuration du dashboard',
                save: 'Enregistrer',
                saving: 'Enregistrement...',
                reset: 'Réinitialiser',
                enabled: 'Activé',
            },
        },
        admin: {
            dashboard: 'Tableau de bord',
            or: 'ou',
            'search-member-input': ' Rechercher un membre',
            'search-coach-input': ' Rechercher un coach',
            'users-title': 'Utilisateurs',
            carousel: {
                title: 'Diaporama',
                addImage: 'Ajouter une image',
                settings: 'Paramètres',
                interval: 'Intervalle (secondes)',
                transition: 'Transition',
                transitionFade: 'Fondu',
                transitionSlide: 'Glissement',
                delete: 'Supprimer',
                active: 'Actif',
                inactive: 'Inactif',
                order: 'Ordre',
                noImages: 'Aucune image disponible',
                addImageSuccess: 'Image ajoutée avec succès',
                deleteImageSuccess: 'Image supprimée avec succès',
                updateSettingsSuccess: 'Paramètres mis à jour avec succès',
                updateOrderSuccess: 'Ordre mis à jour avec succès',
                toggleActiveSuccess: 'Statut mis à jour avec succès',
            },
            badnet: {
                'sync-button': 'Synchroniser BadNet',
                syncing: 'Synchronisation...',
                'sync-success': 'Synchronisation réussie !',
                'sync-error': 'Erreur lors de la synchronisation',
                'tournaments-synced': 'tournois synchronisés',
                'tournaments-success': 'réussis',
                'tournaments-failed': 'échoués',
                title: 'Calendrier des Compétitions',
                'delete-old': 'Supprimer les anciens tournois',
                total: 'Total',
                upcoming: 'À venir',
                past: 'Passés',
                'sync-scheduled': 'Synchronisation planifiée. Le job sera lancé automatiquement dans 30 minutes.',
                queue: {
                    title: 'Queue job',
                    pause: 'Mettre en pause',
                    resume: 'Reprendre',
                    pauseSuccess: 'Queue mise en pause avec succès',
                    resumeSuccess: 'Queue reprise avec succès',
                    deleteOld: 'Supprimer les anciens jobs',
                    deleteOldSuccess: 'anciens jobs supprimés',
                    createJob: 'Créer un job',
                    createJobSuccess: 'Job créé avec succès',
                    createJobTitle: 'Créer un nouveau job',
                    processJobSuccess: 'Job exécuté avec succès',
                    execute: 'Exécuter',
                    jobDetailsTitle: 'Détails du job',
                    filter: {
                        status: 'Statut',
                        action: 'Action',
                        searchPlaceholder: 'Rechercher dans le payload...',
                    },
                    actions: {
                        syncTournaments: 'Synchroniser tous les tournois',
                        syncTournament: 'Synchroniser un tournoi',
                        updateMemberCount: 'Mettre à jour les membres',
                    },
                    form: {
                        action: 'Action',
                        payload: 'Payload (JSON)',
                    },
                    stats: {
                        total: 'Total',
                        pending: 'En attente',
                        processing: 'En cours',
                        completed: 'Terminés',
                        failed: 'Échoués',
                        paused: 'En pause',
                    },
                    table: {
                        id: 'ID',
                        action: 'Action',
                        status: 'Statut',
                        attempts: 'Tentatives',
                        createdAt: 'Créé le',
                        updatedAt: 'Mis à jour le',
                        completedAt: 'Exécuté le',
                        scheduledAt: 'Planifié le',
                        lastError: 'Dernière erreur',
                        payload: 'Payload',
                    },
                },
            },
        },
        coach: {
            dashboard: 'Tableau de bord',
            'my-members': 'Mes membres',
            'my-sessions': 'Mes séances',
            'select-members': 'Sélectionner des membres',
            'members-added': 'Membres ajoutés',
            skills: 'Compétences',
            'skill-already-exist': 'Cette compétence existe déjà',
            'add-skill': 'Ajouter une compétence',
            'skill-edited': 'Compétence modifiée',
            'skill-deleted': 'Compétence supprimée',
            'members-removed': 'Membres retirés',
            '4-players-with-most-missings': 'Les 4 joueurs avec le plus de lacunes',
            'skills-least-mastered': 'Les compétences les moins maîtrisées',
            noGroupsWithMembers: 'Aucun groupe avec des membres trouvé',
            noPlayersWithMissings: 'Aucun joueur avec des lacunes dans ce groupe',
            noSkillsToDisplay: 'Aucune compétence à afficher pour ce groupe',
            trainingSessionGroups: {
                title: 'Groupes de sessions',
                createTitle: 'Créer un groupe',
                editTitle: 'Modifier le groupe',
                members: 'Membres',
                deleteSuccess: 'Le groupe a été supprimé avec succès',
                deleteError: 'Une erreur est survenue lors de la suppression du groupe',
                createSuccess: 'Le groupe a été créé avec succès',
                createError: 'Une erreur est survenue lors de la création du groupe',
                updateSuccess: 'Le groupe a été mis à jour avec succès',
                updateError: 'Une erreur est survenue lors de la mise à jour du groupe',
                form: {
                    title: 'Titre',
                    description: 'Description',
                },
                filters: {
                    search: 'Rechercher',
                    searchPlaceholder: 'Rechercher un groupe...',
                },
                shareWithCoaches: 'Partager avec des coachs',
                shareWithCoachesHelp: 'Sélectionnez les coachs avec qui partager ce groupe de sessions',
            },
            trainingSessions: {
                title: "Mes séances d'entraînement",
                filterByIntensity: 'Filtrer par intensité',
                noSessions: 'Aucune séance trouvée',
                steps: 'Étapes',
                startTime: 'Heure de début',
                endTime: 'Heure de fin',
                createdSuccess: 'La séance a été créée avec succès',
                updatedSuccess: 'La séance a été mise à jour avec succès',
                exercise: 'Exercice',
                addStep: 'Ajouter une étape',
                deleteSuccess: 'La séance a été supprimée avec succès',
                deleteError: 'Une erreur est survenue lors de la suppression de la séance',
                createSuccess: 'La séance a été créée avec succès',
                createError: 'Une erreur est survenue lors de la création de la séance',
                updateSuccess: 'La séance a été mise à jour avec succès',
                updateError: 'Une erreur est survenue lors de la mise à jour de la séance',
                toggleCompleteSuccess: 'Le statut de la séance a été mis à jour avec succès',
                toggleCompleteError: 'Une erreur est survenue lors de la mise à jour du statut de la séance',
                duplicateSuccess: 'La séance a été dupliquée avec succès',
                duplicateError: 'Une erreur est survenue lors de la duplication de la séance',
                duplicateSession: 'Dupliquer la séance',
                selectDestinationGroup: 'Sélectionnez le groupe de destination pour la séance dupliquée',
                destinationGroup: 'Groupe de destination',
                selectGroup: 'Sélectionnez un groupe',
                session: 'séance',
                newSession: 'Nouvelle séance',
                editSession: 'Modifier la séance',
                viewMembers: 'Voir les membres',
                groupMembers: 'Membres du groupe',
                description: 'Description',
                intensity: 'Intensité',
                intensityLow: 'Faible',
                intensityMedium: 'Moyenne',
                intensityHigh: 'Élevée',
                intensityVeryHigh: 'Très élevée',
                intensityExtreme: 'Extrême',
                group: 'Groupe',
                noGroup: 'Aucun groupe',
                groupPlaceholder: 'Sélectionnez un groupe',
                groupHelp: 'Optionnel - Associez cette session à un groupe existant',
                sessionDescriptionPlaceholder: 'Décrivez le contenu de la séance...',
                sessionTitlePlaceholder: 'Entrez le titre de la séance',
                sessionSteps: 'Étapes de la séance',
                stepTitle: 'Titre',
                stepStartTime: 'Heure de début',
                stepEndTime: 'Heure de fin',
                stepExercise: 'Exercice associé (optionnel)',
                stepDescription: 'Description (optionnel)',
                noExercise: 'Aucun exercice',
                addStepButton: 'Ajouter une étape',
                deleteStep: 'Supprimer cette étape',
                step: 'Étape',
                stepNumber: 'Étape {{number}}',
                moveUp: 'Déplacer vers le haut',
                moveDown: 'Déplacer vers le bas',
                viewExercise: "Voir les détails de l'exercice",
                generateExercise: 'Générer un exercice',
                loading: '...',
                errors: {
                    titleRequired: 'Le titre est requis',
                    stepTitleRequired: "Le titre de l'étape {{index}} est requis",
                    invalidTimeRange: "L'heure de fin doit être postérieure à l'heure de début (étape {{index}})",
                    overlappingSteps: 'Les étapes {{step1}} et {{step2}} se chevauchent',
                    authRequired: 'Authentification requise',
                    genericError: 'Une erreur est survenue',
                    errorOccurred: 'Une erreur est survenue',
                    sessionRequired: 'Session requise',
                },
            },

            // Gestion des exercices
            exercises: {
                title: 'Exercices',
                addExercise: 'Ajouter un exercice',
                searchPlaceholder: 'Rechercher un exercice...',
                filters: {
                    intensity: 'Intensité',
                    gameType: 'Type de jeu',
                    courtType: 'Type de terrain',
                    peopleCount: 'Nombre de personnes',
                    skills: 'Compétences',
                    all: 'Toutes',
                    gameTypeSingles: 'Simple',
                    gameTypeDoubles: 'Double',
                    gameTypeBoth: 'Les deux',
                    courtTypeFull: 'Complet',
                    courtTypeHalf: 'Demi-terrain',
                    courtTypeBoth: 'Les deux',
                },
                exerciseItem: {
                    people: 'personne',
                    people_plural: 'personnes',
                    intensity: 'Intensité :',
                    gameType: 'Type de jeu :',
                    courtType: 'Type de terrain :',
                    skills: 'Compétences :',
                    intensityEnum: {
                        LOW: 'Basse',
                        MEDIUM: 'Moyenne',
                        HIGH: 'Haute',
                    },
                    gameTypeEnum: {
                        SINGLES: 'Simple',
                        DOUBLES: 'Double',
                        BOTH: 'Les deux',
                    },
                    courtTypeEnum: {
                        FULL: 'Complet',
                        HALF: 'Demi-terrain',
                        BOTH: 'Les deux',
                    },
                    peopleCountEnum: {
                        SINGLE: '1 personne',
                        PAIR: '2 personnes',
                        GROUP: 'Groupe',
                        ANY: 'Tous',
                    },
                },
                createSuccess: "L'exercice a été créé avec succès",
                createError: "Une erreur est survenue lors de la création de l'exercice",
                updateSuccess: "L'exercice a été mis à jour avec succès",
                updateError: "Une erreur est survenue lors de la mise à jour de l'exercice",
                deleteSuccess: "L'exercice a été supprimé avec succès",
                deleteError: "Une erreur est survenue lors de la suppression de l'exercice",
                deleting: 'Suppression...',
                exercise: 'un exercice',
                description: 'Description',
                peopleCount: 'Nombre de personnes',
                intensity: 'Intensité',
                intensityLow: 'Basse',
                intensityMedium: 'Moyenne',
                intensityHigh: 'Haute',
                gameType: 'Type de jeu',
                gameTypeSingles: 'Simple',
                gameTypeDoubles: 'Double',
                gameTypeBoth: 'Les deux',
                courtType: 'Type de terrain',
                courtTypeFull: 'Complet',
                courtTypeHalf: 'Demi-terrain',
                courtTypeBoth: 'Les deux',
                skills: 'Compétences',
                generatedFrom: 'Généré depuis',
                generateSuccess: "L'exercice a été généré et associé avec succès",
                generateError: "Une erreur est survenue lors de la génération de l'exercice",
            },
            // Compétences et catégories
            parentSkills: 'Catégories de compétences',
            'skill-create-error': 'Une erreur est survenue lors de la création de la catégorie',
            'skill-edit-error': 'Une erreur est survenue lors de la mise à jour de la catégorie',
            'skill-delete-error': 'Une erreur est survenue lors de la suppression de la catégorie',
            'skill-created': 'Catégorie créée avec succès',
            'skill-updated': 'Catégorie mise à jour avec succès',
        },
        member: {
            dashboard: 'Tableau de bord',
            documentation: 'Documentation',
            'search-document-input': 'Rechercher un document...',
            'my-followed-skills': 'Mes compétences suivies',
            'my-progression': 'Ma progression',
            'my-documentation': 'Ma documentation',
            'edit-password': 'Modifier mon mot de passe',
            'search-skill-input': 'Rechercher une compétence',
            'satisfaction-survey': 'Questionnaire de satisfaction',
            'satisfaction-survey-iframe-fallback':
                'Le questionnaire de satisfaction ne peut pas être affiché. Veuillez cliquer sur ce lien pour y accéder.',
            'notify-skill-changes': 'Recevoir des notifications par email lors des mises à jour de mes compétences',
            'notification-preference-updated': 'Préférence de notification mise à jour avec succès',
            'welcome-1': 'Bonjour {{ user.firstname }} {{ user.lastname }},',
            'welcome-2': 'Bienvenue dans ton espace BVA.',
            'welcome-4': 'Dans le futur, de nouvelles fonctionnalités peuvent faire leur apparition.',
            'welcome-5':
                "Si tu as des idées pour faire évoluer le site, n'hésite pas à les envoyer à l'adresse mail : president@bva-club.fr.",
            'last-news': 'Derniers articles',
            'change-password-title': 'Modifier mon mot de passe',
            'current-password-label': 'Mot de passe actuel',
            'new-password-label': 'Nouveau mot de passe',
            'confirm-password-label': 'Confirmer le nouveau mot de passe',
            'skill-updated': 'Votre compétence a bien été mise à jour',
        },
        error: {
            'session-expired': 'Votre session a expiré, vous allez être déconnecté par mesure de sécurité.',
        },
        page: {
            planning: {
                joyride: {
                    body: {
                        title: 'Horaires & Tarifs',
                        content: "Petite visite guidée pour savoir où poser l'œil et ne rien rater !",
                    },
                    'help-btn': {
                        title: 'Bouton Guidez-moi !',
                        content: 'Ce bouton relance la visite guidée.',
                    },
                    'planning-holidays': {
                        title: 'Planning des vacances scolaires',
                        content: 'Ce planning correspond aux séances disponibles durant les vacances scolaires !',
                    },
                    'planning-summer': {
                        title: "Planning des vacances d'été",
                        content: "Ce planning correspond aux séances disponibles durant les vacances d'été !",
                    },
                    legend: {
                        title: 'La légende',
                        content:
                            'Chaque planning contient la légende cette légende vous aidera a mieux comprendre le planning.',
                    },
                    planning: {
                        title: 'Planning principal',
                        content: "Ce planning correspond aux séances principales qui auront lieu durant toute l'année.",
                    },
                    try: {
                        title: "Les séances d'essai",
                        content: 'Si vous êtes nouveau ça devrait vous intéresser !',
                    },
                    'our-prices': {
                        title: 'Nos licences',
                        content:
                            "Une fois que vous avez effectué au moins une séance d'essais, vous pouvez nous demander le formulaire d'inscription. Dans celui-ci, vous pourrez choisir la licence qui vous correspond ainsi que le moyen de paiement souhaité.",
                    },
                },
                'summer-sessions':
                    "Les créneaux d'été sont ouverts à tous pendant les vacances d'été. C'est le bon moment pour venir essayer et s'amuser avec nous sur les terrains.",
            },
            contact: {
                title: 'Contactez-nous',
            },
            price: {
                title: 'Tarifs de la saison {{season}}',
                'title-try': "Séances d'essai",
                'price-try-1':
                    "Il vous faut contacter le club par mail ou par téléphone, vous les trouverez sur la page <a href='{{contactLink}}'>Contactez-nous</a>.",
                'price-try-2': "Avant de vous inscrire vous avez droit à 3 séances d'essai.",
                'price-try-3': 'Durant celle-ci nous pouvons vous prêter des raquettes et des volants.',
                'price-try-4': 'Au-delà, il vous faudra ramener vos raquettes et vos volants.',
                'register-info-date':
                    'Les inscriptions pour les renouvellements des joueurs déjà inscrit cette saison ouvriront quand nous auront défini les horaires pour la saison suivantes. Et début septembre pour les nouveaux membres à la rentrée scolaire. Une communication sera faite et vous verrez les différents tarifs affichés ici.',
                'warning-off-day': '⚠️ Attention : Le club ferme toujours lors des jours fériés ! ⚠️',
            },
            badnetTournament: {
                title: 'Calendrier des Compétitions',
                upcoming: 'À venir',
                past: 'Passés',
                'no-data': 'Aucun tournoi disponible pour le moment.',
                'no-tournaments-day': 'Aucun tournoi ce jour-là.',
                date: 'Date',
                place: 'Lieu',
                categories: 'Catégories',
                classifications: 'Classements',
                deadline: 'Date limite',
                participants: 'Participants',
                register: "S'inscrire sur BadNet",
                helloasso: "S'inscrire sur HelloAsso",
                promoted: 'Promu',
                bvaMembers: 'membres BVA',
                bvaMembersLegend: 'Membres BVA inscrits',
                remainingPlaces: 'places restantes',
            },
            login: {
                connexion: 'Connexion',
                member: 'Membre',
                coach: 'Coach',
                admin: 'Administrateur',
                'account-type': 'Type de compte',
                'select-account-type': 'Sélectionnez un type de compte',
                'connection-success': 'Connexion réussie',
                'go-to-member-space': "Aller à l'espace membre",
                'go-to-coach-space': "Aller à l'espace coach",
                'go-to-admin-space': "Aller à l'espace admin",
                'forgot-password': 'Mot de passe oublié ?',
                'reset-password': 'Réinitialiser le mot de passe',
                'reset-password-email-sent': 'Un email de réinitialisation a été envoyé',
                'send-email': 'Envoyer',
                'pseudo-placeholder': 'Votre pseudo',
                'pseudo-received-by-email': 'Pseudo * (reçu par email)',
                'enter-email': 'Entrez votre email',
                'enter-email-or-pseudo': 'Entrez votre email ou pseudo',
                'enter-password': 'Entrez votre mot de passe',
                pseudo: 'Pseudo',
                'enter-pseudo': 'Entrez votre pseudo',
                email: 'Adresse email',
                'email-placeholder': 'Entrez votre adresse email',
                'email-label': 'Email',
                'email-or-pseudo': 'Email ou pseudo',
                password: 'Mot de passe',
                connect: 'Se connecter',
            },
        },
        joyride: {
            help: 'Guidez-moi !',
            next: 'Suivant',
            last: 'Terminer la visite',
            skip: 'Fermer',
            back: 'Précédent',
            close: 'Fermer',
        },
        bot: {
            init: 'Bonjour ! Que puis-je faire pour vous ? Vous pouvez me poser des petites questions ou utiliser des mots clés, par exemple le mot "horaires" vous redirigera vers la page horaires et tarifs. Pour tout message long merci de contacter le BVA à l\'adresse mail suivante : contact@bva-club.fr',
        },
        cookies: "Ce site utilise des cookies qui ne durent qu'un jour afin de mesurer l'audience.",
        skill: { TO_DISCOVER: 'À découvrir', STARTED: 'Commencé', CONFIRMED: 'Confirmé', MASTERED: 'Maîtrisé' },
        shop: {
            title: 'Boutique',
            products: 'Produits',
            cart: 'Panier',
            checkout: 'Commander',
            orders: 'Commandes',
            orderHistory: 'Historique des commandes',
            status: 'Statut',
            addToCart: 'Ajouter au panier',
            removeFromCart: 'Retirer du panier',
            quantity: 'Quantité',
            quantity_plural: 'Quantités',
            price: 'Prix',
            stock: 'Stock disponible',
            outOfStock: 'Rupture de stock',
            lowStock: 'Stock faible',
            total: 'Total',
            subtotal: 'Sous-total',
            discount: 'Promo',
            paymentMethod: 'Mode de paiement',
            imageGallery: "Galerie d'images",
            clickToZoomIn: 'Cliquez pour zoomer',
            clickToZoomOut: 'Cliquez pour dézoomer',
            paymentMethods: {
                cash: 'Espèces',
                transfer: 'Virement',
                card: 'Carte bancaire',
            },
            uploadProof: 'Téléverser la preuve de paiement (optionnel)',
            uploadHelloAssoProof: 'Téléverser la preuve de paiement HelloAsso',
            proofRequired: 'Preuve de paiement requise',
            proofOptional: 'Preuve de paiement optionnelle - vous pourrez l\'ajouter plus tard via l\'historique des commandes',
            orderStatus: {
                pending: 'En attente',
                validated: 'Validé',
                cancelled: 'Annulé',
                refunded: 'Annulé et remboursé',
            },
            paymentInstructions: {
                cash: 'Payez en espèces lors de la récupération de ta commande.',
                transfer: 'Effectuez un virement bancaire. La preuve de paiement est optionnelle.',
                card: 'Payez en ligne via HelloAsso. Aucune preuve de paiement requise.',
                cardUpdated: 'Payez en ligne via HelloAsso. Le paiement est géré directement par leur plateforme.',
            },
            transferInstructions:
                "💡 Vous pourrez ajouter la preuve de paiement plus tard via l'historique des commandes.",
            cashPaymentReminder: 'Pense à prendre ton argent le jour de la transaction.',
            cardPaymentInstructions:
                'Payez via HelloAsso. Aucune preuve de paiement requise - le paiement est géré directement par leur plateforme sécurisée.',
            cardPaymentRedirect:
                'Vous allez être redirigé vers HelloAsso pour effectuer votre paiement sécurisé avec le montant pré-rempli.',
            loadingPaymentLink: 'Chargement du lien de paiement...',
            iban: 'IBAN BVA',
            ibanCopied: 'IBAN copié !',
            joyride: {
                welcome: {
                    title: 'Bienvenue dans la boutique BVA',
                    content:
                        'Découvrez comment naviguer dans notre boutique, ajouter des articles au panier et passer commande.',
                },
                filters: {
                    title: 'Filtres et recherche',
                    content:
                        'Utilisez ces filtres pour trouver les produits par catégorie, prix ou nom. Vous pouvez également rechercher des articles spécifiques.',
                },
                cart: {
                    title: 'Votre panier',
                    content: 'Cliquez ici pour voir votre panier, modifier les quantités et passer à la caisse.',
                },
                help: {
                    title: "Bouton d'aide",
                    content: 'Cliquez sur ce bouton pour relancer ce tutoriel à tout moment.',
                },
                product: {
                    title: 'Fiche produit',
                    content:
                        "Voici une fiche produit. Vous pouvez voir le stock disponible, le prix et ajouter l'article au panier en cliquant sur le bouton.",
                },
                checkoutWelcome: {
                    title: 'Finalisation de commande',
                    content: 'Voici la dernière étape ! Choisissez votre mode de paiement et validez votre commande.',
                },
                cartItems: {
                    title: 'Articles du panier',
                    content: 'Vérifiez vos articles, modifiez les quantités si nécessaire et appliquez des promotions.',
                },
                paymentMethod: {
                    title: 'Mode de paiement',
                    content: 'Sélectionnez votre mode de paiement : espèces, virement bancaire ou carte via HelloAsso.',
                },
                checkoutHelp: {
                    title: 'Aide checkout',
                    content: 'Cliquez sur ce bouton pour relancer ce tutoriel de paiement.',
                },
            },
            payWithHelloAsso: 'Payer via HelloAsso',
            helloAssoInstructions:
                'Cliquez sur le bouton ci-dessous pour payer chaque article via HelloAsso. Vous serez redirigé vers la plateforme de paiement sécurisée.',
            noHelloAssoUrl: "Ce produit n'a pas de lien de paiement HelloAsso configuré.",
            helloAssoScreenshot:
                "⚠️ Important : Prenez une capture d'écran de la preuve de paiement après l'avoir effectué via HelloAsso.",
            cardPaymentPopup: {
                title: 'Paiement par carte bancaire',
                instructions:
                    'Cliquez sur le bouton ci-dessous pour effectuer votre paiement sécurisé via HelloAsso. Une fois le paiement effectué, vous pourrez valider votre commande.',
                buttonClicked: 'Merci ! Vous pouvez maintenant valider votre commande.',
                close: 'Fermer',
                loading: 'Chargement du lien de paiement...',
            },
            helloAssoContributionWarning: {
                title: '⚠️ Contribution HelloAsso',
                message:
                    'Vous pouvez retirer le don automatique en cliquant sur le bouton "Modifier" lors du paiement puis en changeant la valeur par 0.',
                imageAlt: "Capture d'écran montrant le bouton Modifier HelloAsso",
            },
            transferPaymentPopup: {
                title: 'Paiement par virement bancaire',
                instructions: "Effectuez un virement vers l'IBAN ci-dessous et téléversez votre preuve de paiement.",
                uploadInstructions: "Téléversez une capture d'écran ou un document PDF de votre preuve de paiement.",
                fileTypes: 'Formats acceptés : PNG, JPG, PDF (max 5MB)',
                uploadSuccess:
                    'Preuve de paiement téléversée avec succès ! Vous pouvez maintenant valider votre commande.',
                close: 'Fermer',
            },
            qrCode: 'Code QR',
            qrCodeSize: 'Taille du code QR',
            scanQRCode: 'Scanner le code QR',
            orderConfirmation: 'Confirmation de commande',
            orderCreated: 'Commande créée avec succès',
            qrCodeInstructions: {
                title: 'Instructions pour le code QR',
                screenshot: "📸 Prenez une capture d'écran de ce code QR",
                present: "👤 Présentez-le à l'administrateur lors de la récupération de votre commande",
                retrievable: '💡 Ce code QR est également disponible dans votre historique de commandes',
            },
            viewOrderHistory: "Voir l'historique des commandes",
            productOutOfStock: "{{productName}} : Le dernier produit vient d'être acheté !",
            insufficientStock: '{{productName}} : Stock insuffisant',
            productRemovedFromCart: "{{productName}} a été retiré de votre panier car il n'est plus en stock.",
            quantityAdjusted: 'La quantité de {{productName}} a été ajustée à {{newQuantity}}.',
            productDeactivated: '{{productName}} a été désactivé et retiré de votre panier.',
            orderValidated: 'Commande validée avec succès',
            orderCancelled: 'Commande annulée avec succès',
            cancelOrder: 'Annuler la commande',
            cancelOrderConfirm: 'Êtes-vous sûr de vouloir annuler cette commande ?',
            uploadProofSuccess: 'Preuve de paiement téléversée avec succès',
            uploadProofError: 'Erreur lors du téléversement de la preuve de paiement',
            noOrders: 'Aucune commande trouvée',
            noProducts: 'Aucun produit disponible',
            searchProducts: 'Rechercher des produits',
            filterByCategory: 'Filtrer par catégorie',
            allCategories: 'Toutes les catégories',
            allStatus: 'Tous les statuts',
            sortBy: 'Trier par',
            sortByName: 'Nom',
            sortByPriceAsc: 'Prix croissant',
            sortByPriceDesc: 'Prix décroissant',
            resultsCount: '{{count}} produit(s) trouvé(s)',
            productAddedToCart: 'Produit ajouté au panier',
            openCart: 'Ouvrir le panier',
            orderDetails: 'Détails de la commande',
            orderItems: 'Articles de la commande',
            paymentProof: 'Preuve de paiement',
            viewProof: 'Voir la preuve',
            selectDiscount: 'Sélectionner une réduction',
            noDiscount: 'Aucune réduction',
            admin: {
                products: 'Produits',
                manageProducts: 'Gérer les produits',
                manageOrders: 'Gérer les commandes',
                searchOrders: 'Rechercher des commandes',
                scanner: 'Scanner QR',
                scannerLink: 'Scanner QR Code',
                scanning: 'Recherche de la commande...',
                cameraAccessDenied: 'Accès à la caméra refusé. Veuillez vérifier les permissions de votre navigateur.',
                cameraPermissionDenied:
                    "Permission caméra refusée. Autorisez l'accès à la caméra dans votre navigateur.",
                cameraNotFound: 'Aucune caméra détectée sur cet appareil.',
                stockManagement: 'Gestion du stock',
                addProduct: 'Ajouter un produit',
                editProduct: 'Modifier le produit',
                deleteProduct: 'Supprimer le produit',
                validateOrder: 'Valider la commande',
                cancelOrder: 'Annuler la commande',
                viewProof: 'Voir la preuve de paiement',
                exportOrders: 'Exporter les commandes',
                exportCSV: 'Exporter en CSV',
                helloassoUrl: 'URL HelloAsso',
                image: 'Image',
                name: 'Nom',
                description: 'Description',
                discounts: 'Réductions',
                category: 'Catégorie',
                exactStock: 'Stock exact',
                stockAlert: 'Alerte de stock',
                lowStockThreshold: 'Seuil de stock faible',
                stockAlertTitle: 'Alertes de stock',
                stockAlertDescription: 'Produits avec un stock faible',
                noLowStockProducts: 'Aucun produit avec un stock faible',
                viewProduct: 'Voir le produit',
                orders: 'Commandes',
                orderValidated: 'Commande validée avec succès',
                orderCancelled: 'Commande annulée avec succès',
                orderRefunded: 'Commande remboursée avec succès',
                confirmValidate: 'Êtes-vous sûr de vouloir valider cette commande ?',
                confirmCancel: 'Êtes-vous sûr de vouloir annuler cette commande ?',
                confirmRefund: 'Êtes-vous sûr de vouloir confirmer le remboursement de cette commande ?',
                noOrdersToExport: 'Aucune commande à exporter',
                orderDetails: 'Détails de la commande',
                userId: 'ID Utilisateur',
                user: 'Utilisateur',
                date: 'Date',
                status: 'Statut',
                paymentMethod: 'Méthode de paiement',
                totalPrice: 'Prix total',
                paymentProof: 'Preuve de paiement',
                validatedBy: 'Validé par',
                refundedAt: 'Remboursé le',
                qrCodeUuid: 'UUID du code QR',
                items: 'Articles',
                orderItems: 'Articles de la commande',
                product: 'Produit',
                quantity: 'Quantité',
                price: 'Prix',
                subtotal: 'Sous-total',
                validationModal: 'Validation de commande',
                reviewOrder: 'Revoir la commande',
                reviewPaymentProof: 'Revoir la preuve de paiement',
                noPaymentProof: 'Aucune preuve de paiement fournie',
                validate: 'Valider',
                cancel: 'Annuler',
                close: 'Fermer',
                updateStock: 'Mettre à jour le stock',
                stockUpdated: 'Stock mis à jour avec succès',
                productCreated: 'Produit créé avec succès',
                productUpdated: 'Produit mis à jour avec succès',
                productDeleted: 'Produit supprimé avec succès',
                confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
                nameRequired: 'Nom requis',
                descriptionRequired: 'Description requise',
                priceRequired: 'Le prix doit être supérieur à 0',
                discountNameRequired: 'Nom de la réduction requis',
                discountAmountRequired: 'Le montant de la réduction doit être positif ou nul',
                discountPercentageRange: 'Le pourcentage doit être entre 0 et 100',
                stockRequired: 'Le stock doit être positif ou nul',
                invalidUrl: 'URL invalide',
                addDiscount: 'Ajouter une réduction',
                removeDiscount: 'Supprimer',
                discountName: 'Nom de la réduction',
                discountAmount: 'Montant',
                discountType: 'Type de réduction',
                fixedAmount: 'Montant fixe (€)',
                percentage: 'Pourcentage (%)',
                firstItemOnly: '1er article uniquement',
                excludeMembers: 'Exclure les membres',
                startDate: 'Date de début',
                endDate: 'Date de fin',
                sortDateDesc: 'Date décroissante',
                sortDateAsc: 'Date croissante',
                sortPriceDesc: 'Prix décroissant',
                sortPriceAsc: 'Prix croissant',
                sortIdAsc: 'ID croissant',
                sortIdDesc: 'ID décroissant',
            },
        },
    }
}

export default frTranslation
